module.exports = __webpack_public_path__ + "38df5ccdd5d92d160a54ed2a11326cf1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/snowflakes.png
// module id = 2759
// module chunks = 0